import lazyLoadView from "@router-utils/lazyload-view";
import routeError from "@router-utils/route-error";
import mergeContainerOrderItemForDetail from '@router-utils/merge-container-order-item'
import store from '@store'
import _values from 'lodash/values'
import { formatOrderStatusTitle } from "@utils/format-order";
import { formatOrderPrepaidStatusTitle } from "@utils/format-order-prepaid"

export default [
  // ===
  // 預約結帳
  // ===
  /*   {
    path: '/store/:storeAlias/reservation/:reservationAlias/checkout',
    name: 'reservation-checkout',
    component: () => lazyLoadView(import('@views/Checkout/Index.Jtails')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          if (!store.getters['merchant/isSiteEnabled'])
          next({ name: '404' })
          const [
            currentCart
          ] = await Promise.all([
            store.dispatch('cart/fetchCart', {
              mockType: routeFrom.query.prepaidId
                ? 'deduct'
                : 'reservation'
            }),
          ]);

          const isCartNull = !currentCart.items.booking[0];
          const re = /[0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1]) (2[0-3]|[01][0-9]):[0-5][0-9]/;
          const date = !isCartNull && re.test(currentCart.items.booking[0].inventoryAlias) ? currentCart.items.booking[0].inventoryAlias : undefined

          if(isCartNull) {
            alert(`您的預約購物車是空的 \n 系統將重新導向至至首頁`);

            return next({ name: 'reservation' });
          } else {
            routeTo.params.cart = currentCart.items.booking[0];
          }

          const [
            currentMemberPetList,
            currentMember,
            currentApplicablePrepaidOrderList
          ] = await Promise.all([
            store.dispatch('auth/fetchMemberPetList', {
              useCached: true
            }),
            store.dispatch('auth/fetchMember'),
            store.dispatch('order/fetchApplicablePrepaidOrderList', {
              paramAlias: routeTo.params.cart.param.alias,
              useCached: false,
              storeCached: false,
              date
            }),
          ]);

          routeTo.params.applicablePrepaidOrderList = currentApplicablePrepaidOrderList.items;

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      isLoginPage: true,
      liffShowMenu: false,
    },
    props: (route) => ({
      cart: route.params.cart || {},
      cartType: 'reservation',
      applicablePrepaidOrderList: route.params.applicablePrepaidOrderList || []
    }),
  }, */
  // ===
  // 預約結帳 未付款結帳
  // ===
  /*   {
    path: '/store/:storeAlias/reservation/:reservationAlias/checkout/:orderId',
    name: 'reservation-unpaid-checkout',
    component: () => lazyLoadView(import('@views/Checkout/Index.Jtails')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const planAlias = store.state.merchant.currentMerchant?.planAlias || 'normal';

          if(planAlias === 'normal') {
            alert(`您的預約無法使用線上付款\n系統將重新導向到訂單頁面⋯⋯`);

            next({
              name: 'reservation-checkout-detail',
              params: { orderId: routeTo.params.orderId },
            })
          }

          const [
            currentReservationOrderItem
          ] = await Promise.all([
            store.dispatch('order/fetchReservationOrderItem', {
              orderId: routeTo.params.orderId
            }),
          ]);

          const {
            paymentStatus: currentOrderPaymentStatus,
            paymentMethod: currentOrderPaymentMethod
          } = currentReservationOrderItem.items;

          if(currentOrderPaymentMethod !== 'Credit' && currentOrderPaymentMethod !== null) {
            alert(`您的預約無法使用線上付款\n系統將重新導向到訂單頁面⋯⋯`);

            next({
              name: 'reservation-checkout-detail',
              params: { orderId: routeTo.params.orderId },
            })
          }

          if(currentOrderPaymentStatus !== 'UNPAID') {
            alert(`您的預約${formatOrderStatusTitle[currentReservationOrderItem.items]}\n系統將重新導向到訂單頁面⋯⋯`);

            next({
              name: 'reservation-checkout-detail',
              params: { orderId: routeTo.params.orderId },
            })
          }

          routeTo.params.cart = {
            orderExtrafields: {
              byOrder: _values(currentReservationOrderItem.items.byOrderExtrafields)
            },
            ...currentReservationOrderItem.items
          };

          if(!store.getters['auth/isLoggedIn']) {
            routeTo.params.applicablePrepaidOrderList = [];

            return next()
          }

          const [
            currentMemberPetList,
            currentMember,
            currentApplicablePrepaidOrderList
          ] = await Promise.all([
            store.dispatch('auth/fetchMemberPetList', {
              useCached: true
            }),
            store.dispatch('auth/fetchMember'),
            store.dispatch('order/fetchApplicablePrepaidOrderList', {
              paramAlias: routeTo.params.reservationAlias,
              useCached: false,
              storeCached: false
            }),
          ]);

          routeTo.params.applicablePrepaidOrderList = currentApplicablePrepaidOrderList.items;

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      liffShowMenu: false,
    },
    props: (route) => ({
      cart: route.params.cart || {},
      cartType: 'reservation',
      applicablePrepaidOrderList: route.params.applicablePrepaidOrderList || [],
      isUnpaid: true
    }),
  }, */
  // ===
  // 訂單
  // ===
  {
    path: '/order/:containerUuId',
    name: 'reservation-checkout-detail',
    component: () => lazyLoadView(import('@views/Checkout/Detail.Jtails')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const [
            responseContainerOrder,
            currentMember
          ] = await Promise.all([
            // 此路由處理一般預約/子單等，勿先打 hotel/order/container；住宿請走 hotel 專用流程
            store.dispatch('order/fetchContainerOrderItem', {
              containerUuId: routeTo.params.containerUuId,
              errorHandle: false,
              showMessage: false,
              logoutRedirect: false,
            }),
            store.dispatch('auth/fetchMember'),
          ]);
          // API 回傳為容器物件本身（或包在 .data、.items），容器頂層有 type、uuid、is_temp
          const container =
            responseContainerOrder?.items ||
            responseContainerOrder?.data ||
            responseContainerOrder;
          const hasContainer = container && (container.uuid != null || container.type != null);

          if (hasContainer) {
            await checkOrder(container, routeTo, next);
            if (container.is_temp) {
              alert('尚未預約完成\n系統將重新導向至預約結帳頁')
              return next({
                name: 'reservation-checkout'
              })
            }
            routeTo.params.orderItem = mergeContainerOrderItemForDetail(container);
            if (container.type === 'deposit') {
              routeTo.params.cartType = 'deposit'
            } else {
              routeTo.params.cartType = container.parent_id ? 'children' : 'reservation'
            }
            return next()
          }

          if (responseContainerOrder?.status === 'MERCHANT_MEMBER_FRONT_MALICIOUS_QUERY_ORDER' && !routeTo.query.status) {
            routeTo.params.isMalicious = true
            return next()
          }
          if (responseContainerOrder?.code === 401) {
            return next({
              name: 'logout',
              query: {
                redirectFrom: routeTo.path
              }
            });
          }
          if (responseContainerOrder?.code === 404) {
            return next({
              name: '404',
            });
          }
          routeTo.params.responseError = responseContainerOrder ?? {};
          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
    },
    props: (route) => ({
      orderItem: route.params.orderItem || {},
      orderType: route.params.cartType,
      responseError: route.params.responseError || {},
      isMalicious: route.params.isMalicious || false
    }),
  },
  // ===
  // 包套方案結帳
  // ===
  {
    path: '/prepaid/:prepaidAlias/checkout',
    name: 'prepaid-checkout',
    component: () => lazyLoadView(import('@views/Checkout/Index.Jtails')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const [
            currentMember,
            currentCart
          ] = await Promise.all([
            store.dispatch('auth/fetchMember'),
            store.dispatch('cart/fetchCart', {
              mockType: 'prepaid'
            }),
          ]);

          const isCartNull = !currentCart.items.prepaid[0];

          if (isCartNull) {
            alert(`您的預約購物車是空的 \n 系統將重新導向至${store.state.merchant.currentMerchant?.prepaidSetting?.title || '包套方案'}頁面`);
            return next({ name: 'prepaid' });
          } else {
            routeTo.params.cart = currentCart.items.prepaid[0];
          }

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      isLoginPage: true,
      liffShowMenu: false,
    },
    props: (route) => ({
      cart: route.params.cart || {},
      cartType: 'prepaid',
    }),
  },
  // ===
  // 包套方案結帳 未付款結帳
  // ===
  {
    path: '/prepaid/:prepaidAlias/checkout/:orderId',
    name: 'prepaid-unpaid-checkout',
    component: () => lazyLoadView(import('@views/Checkout/Index.Jtails')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const planAlias = store.state.merchant.currentMerchant?.planAlias || 'normal';

          if (planAlias === 'normal') {
            alert(`您的${store.state.merchant.currentMerchant?.prepaidSetting?.title || '包套方案'}無法使用線上付款\n系統將重新導向到訂單頁面⋯⋯`);

            next({
              name: 'prepaid-checkout-detail',
              params: { orderId: routeTo.params.orderId },
            })
          }

          const [
            currentPrepaidOrderItem
          ] = await Promise.all([
            store.dispatch('order/fetchPrepaidOrderItem', {
              prepaidOrderId: routeTo.params.orderId
            }),
          ]);

          const {
            status: currentOrderStatus,
            paymentMethod: currentOrderPaymentMethod
          } = currentPrepaidOrderItem.items;

          if (currentOrderPaymentMethod !== 'Credit' && currentOrderPaymentMethod !== null) {
            alert(`您的${store.state.merchant.currentMerchant?.prepaidSetting?.title || '包套方案'}無法使用線上付款\n系統將重新導向到訂單頁面⋯⋯`);

            next({
              name: 'reservation-checkout-detail',
              params: { orderId: routeTo.params.orderId },
            })
          }

          if (currentOrderStatus !== 2) {
            alert(`您的${store.state.merchant.currentMerchant?.prepaidSetting?.title || '包套方案'}${formatOrderPrepaidStatusTitle[currentOrderStatus]}\n系統將重新導向到訂單頁面⋯⋯`);

            next({
              name: 'prepaid-checkout-detail',
              params: { orderId: routeTo.params.orderId },
            })
          }

          routeTo.params.cart = currentPrepaidOrderItem.items;

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      liffShowMenu: false,
    },
    props: (route) => ({
      cart: route.params.cart || {},
      cartType: 'prepaid',
      isUnpaid: true
    }),
  },
  // ===
  // 包套方案訂單
  // ===
  {
    path: '/prepaidorder/:orderId',
    name: 'prepaid-checkout-detail',
    component: () => lazyLoadView(import('@views/Checkout/Detail.Jtails')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const [
            responseOrder,
            currentMember
          ] = await Promise.all([
            store.dispatch('order/fetchPrepaidOrderItem', {
              prepaidOrderId: routeTo.params.orderId,
              errorHandle: false,
              showMessage: false,
              logoutRedirect: false
            }),
            store.dispatch('auth/fetchMember'),
          ]);

          if (responseOrder.items) {
            await checkOrder(responseOrder.items, routeTo, next);

            routeTo.params.orderItem = responseOrder.items;
          } else if (responseOrder.status === 'MERCHANT_MEMBER_FRONT_MALICIOUS_QUERY_ORDER' && !routeTo.query.status) {
            routeTo.params.isMalicious = true
          } else if (responseOrder.code === 401) {
            return next({
              name: 'logout',
              query: {
                redirectFrom: routeTo.path
              }
            });
          } else if (responseOrder.code === 404) {
            return next({
              name: '404',
            });
          } else {
            routeTo.params.responseError = responseOrder;
          }

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
    },
    props: (route) => ({
      orderItem: route.params.orderItem || {},
      orderType: 'prepaid',
      responseError: route.params.responseError || {},
      isMalicious: route.params.isMalicious || false
    }),
  },
  // ===
  // 儲值金方案結帳
  // ===
  {
    path: '/deposit/:depositUuid/checkout',
    name: 'deposit-checkout',
    component: () => lazyLoadView(import('@views/Checkout/Index.Jtails')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        // 是否開放顧客預約前台狀態
        if (!store.getters['merchant/isSiteEnabled']) {
          // next({ name: '404' }) // -> 先關掉，不管是否開放顧客預約前台，都不要跳到404
        }
        try {
          const [
            currentMember,
            currentCart
          ] = await Promise.all([
            store.dispatch('auth/fetchMember'),
            store.dispatch('cart/fetchCart', {
              mockType: 'deposit'
            }),
          ]);
          const isCartNull = !currentCart.items.deposit[0];
          if (isCartNull) {
            alert('您的購物車是空的 \n 系統將重新導向至儲值金方案頁面');
            return next({ name: 'deposit' });
          } else {
            routeTo.params.cart = currentCart.items.deposit[0];
          }
          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      isLoginPage: true,
      liffShowMenu: false,
    },
    props: (route) => ({
      cart: route.params.cart || {},
      cartType: 'deposit',
    }),
  },
  // ===
  // 儲值金方案結帳 未付款結帳
  // ===
  /*   {
    path: '/deposit/:orderId/checkout/:orderId',
    name: 'deposit-unpaid-checkout',
    component: () => lazyLoadView(import('@views/Checkout/Index.Jtails')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const planAlias = store.state.merchant.currentMerchant?.planAlias || 'normal';

          if(planAlias === 'normal') {
            alert(`您的儲值金方案無法使用線上付款\n系統將重新導向到訂單頁面⋯⋯`);

            return next({
              name: 'deposit-checkout-detail',
              params: { orderId: routeTo.params.orderId },
            })
          }

          const [
            currentDepositOrderItem
          ] = await Promise.all([
            store.dispatch('order/fetchReservationOrderItem', {
              orderId: routeTo.params.orderId
            }),
          ]);

          const {
            status: currentOrderStatus,
            paymentMethod: currentOrderPaymentMethod
          } = currentDepositOrderItem.items;

          if(currentOrderPaymentMethod !== 'Credit' && currentOrderPaymentMethod !== null) {
            alert(`您的儲值金方案無法使用線上付款\n系統將重新導向到訂單頁面⋯⋯`);

            return next({
              name: 'deposit-checkout-detail',
              params: { orderId: routeTo.params.orderId },
            })
          }

          if(currentOrderStatus !== 2) {
            alert(`您的儲值金方案${formatOrderPrepaidStatusTitle[currentOrderStatus]}\n系統將重新導向到訂單頁面⋯⋯`);

            return next({
              name: 'deposit-checkout-detail',
              params: { orderId: routeTo.params.orderId },
            })
          }

          routeTo.params.cart = currentDepositOrderItem.items;

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      liffShowMenu: false,
    },
    props: (route) => ({
      cart: route.params.cart || {},
      cartType: 'deposit',
      isUnpaid: true
    }),
  }, */
  // ===
  // 儲值金方案訂單
  // ===
  // {
  //   path: '/depositorder/:orderId',
  //   name: 'deposit-checkout-detail',
  //   component: () => lazyLoadView(import('@views/Checkout/Detail.Jtails')),
  //   meta: {
  //     async beforeResolve(routeTo, routeFrom, next) {
  //       try {
  //         const [
  //           responseOrder,
  //           currentMember,
  //         ] = await Promise.all([
  //           store.dispatch('order/fetchReservationOrderItem', {
  //             orderId: routeTo.params.orderId,
  //             // errorHandle: !routeTo.query.status,
  //             errorHandle: false,
  //             showMessage: false,
  //             logoutRedirect: false
  //           }),
  //           store.dispatch('auth/fetchMember'),
  //         ]);

  //         routeTo.params.isMalicious = false

  //         if(responseOrder.items) {
  //           await checkOrder(responseOrder.items, routeTo, next);

  //           routeTo.params.orderItem = responseOrder.items;
  //         } else if(responseOrder.status === 'MERCHANT_MEMBER_FRONT_MALICIOUS_QUERY_ORDER' && !routeTo.query.status) {
  //           routeTo.params.isMalicious = true
  //         } else if(responseOrder.code === 401) {
  //           return next({
  //             name: 'logout',
  //             query: {
  //               redirectFrom: routeTo.path
  //             }
  //           });
  //         } else {
  //           routeTo.params.responseError = responseOrder;
  //         }

  //         next()
  //       } catch (error) {
  //         routeError(error, routeTo, next({ name: '404' }), next);
  //       }
  //     },
  //   },
  //   props: (route) => ({
  //     orderItem: route.params.orderItem || {},
  //     orderType: 'deposit',
  //     responseError: route.params.responseError || {}
  //   }),
  // },
  // ===
  // 舊版加購訂單
  // ===
  {
    path: '/addorder/:orderId',
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        return next({
          name: 'reservation-checkout-detail',
          params: { orderId: routeTo.params.orderId },
        })
      },
      isNullPage: true,
    },
  },

  // ===
  // 新版多隻前台購物車預約
  // ===
  {
    path: '/reservation/cart/checkout',
    name: 'reservation-checkout',
    component: () => lazyLoadView(import('@views/Checkout/IndexReservation.Jtails')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const [
            currentContainerList
          ] = await Promise.all([
            store.dispatch('merchant/fetchContainerList', {
              types: ['booking'],
              is_temp: 1,
              paginate: 0,
            })
          ]);
          routeTo.params.currentContainerList = currentContainerList.items[0]
          if (!routeTo.params.currentContainerList || !routeTo.params.currentContainerList.orders.items[0]) {
            alert(`您尚未預約任何項目 \n 系統將重新導向至首頁`);
            return next({ name: 'home' });
          }
          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      isLoginPage: true,
      liffShowMenu: false,
    },
    props: (route) => ({
      cartType: 'reservation',
      cart: route.params.currentContainerList || [],
    })
  },

  // ===
  // 新版多隻後台幫客代訂預約 未付款結帳
  // ===
  {
    path: '/reservation/checkout/:containerUuId',
    name: 'reservation-unpaid-checkout',
    component: () => lazyLoadView(import('@views/Checkout/IndexReservation.Jtails')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const planAlias = store.state.merchant.currentMerchant?.planAlias || 'normal';

          if (planAlias === 'normal') {
            alert(`您的預約無法使用線上付款\n系統將重新導向到訂單頁面⋯⋯`);

            return next({
              name: 'reservation-checkout-detail',
              params: { containerUuId: routeTo.params.containerUuId },
            })
          }

          const [
            currentContainerOrderItem
          ] = await Promise.all([
            // 與 /order/ 結帳詳情相同：不先打 hotel/order/container
            store.dispatch('order/fetchContainerOrderItem', {
              containerUuId: routeTo.params.containerUuId
            }),
          ]);

          const container =
            currentContainerOrderItem?.items ||
            currentContainerOrderItem?.data ||
            currentContainerOrderItem;
          const {
            paymentStatus: currentOrderPaymentStatus,
            paymentMethod: currentOrderPaymentMethod
          } = container;

          if (currentOrderPaymentMethod !== 'Credit' && currentOrderPaymentMethod !== null) {
            alert(`您的預約無法使用線上付款\n系統將重新導向到訂單頁面⋯⋯`);

            return next({
              name: 'reservation-checkout-detail',
              params: { containerUuId: routeTo.params.containerUuId },
            })
          }

          if (currentOrderPaymentStatus !== 'UNPAID') {
            alert(`您的預約${formatOrderStatusTitle(container.status, container.paymentStatus, container.cancelDate)}\n系統將重新導向到訂單頁面⋯⋯`);

            return next({
              name: 'reservation-checkout-detail',
              params: { containerUuId: routeTo.params.containerUuId },
            })
          }

          routeTo.params.cart = {
            ...container
          };


          if (!store.getters['auth/isLoggedIn']) {
            routeTo.params.applicablePrepaidOrderList = [];

            return next()
          }

          const [
            currentMemberPetList,
            currentMember,
          ] = await Promise.all([
            store.dispatch('auth/fetchMemberPetList', {
              useCached: true
            }),
            store.dispatch('auth/fetchMember'),
          ]);

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      liffShowMenu: false,
    },
    props: (route) => ({
      cart: route.params.cart || {},
      cartType: 'reservation',
      isUnpaid: true
    }),
  },

  // ===
  // 新版儲值金方案結帳 未付款結帳
  // ===
  {
    path: '/deposit/checkout/:orderId',
    name: 'deposit-unpaid-checkout',
    component: () => lazyLoadView(import('@views/Checkout/IndexReservation.Jtails')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const planAlias = store.state.merchant.currentMerchant?.planAlias || 'normal';

          if (planAlias === 'normal') {
            alert(`您的儲值金方案無法使用線上付款\n系統將重新導向到訂單頁面⋯⋯`);

            return next({
              name: 'deposit-checkout-detail',
              params: { containerUuId: routeTo.params.orderId },
            })
          }
          const [
            currentDepositOrderItem
          ] = await Promise.all([
            store.dispatch('order/fetchContainerOrderItem', {
              containerUuId: routeTo.params.orderId
            }),
          ]);

          const {
            // status: currentOrderStatus,
            paymentMethod: currentOrderPaymentMethod
          } = currentDepositOrderItem.items;

          if (currentOrderPaymentMethod !== 'Credit' && currentOrderPaymentMethod !== null) {
            alert(`您的儲值金方案無法使用線上付款\n系統將重新導向到訂單頁面⋯⋯`);

            return next({
              name: 'deposit-checkout-detail',
              params: { containerUuId: routeTo.params.orderId },
            })
          }

          // if(currentOrderStatus !== 2) {
          //   alert(`您的儲值金方案${formatOrderPrepaidStatusTitle[currentOrderStatus]}\n系統將重新導向到訂單頁面⋯⋯`);

          //   return next({
          //     name: 'deposit-checkout-detail',
          //     params: { containerUuId: routeTo.params.orderId },
          //   })
          // }

          routeTo.params.cart = currentDepositOrderItem.items;

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      liffShowMenu: false,
    },
    props: (route) => ({
      cart: route.params.cart || {},
      cartType: 'deposit',
      isUnpaid: true
    }),
  },
  // ===
  // 新版儲值金方案訂單
  // ===
  {
    path: '/depositorder/:containerUuId',
    name: 'deposit-checkout-detail',
    component: () => lazyLoadView(import('@views/Checkout/Detail.Jtails')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const [
            responseOrder,
            currentMember
          ] = await Promise.all([
            store.dispatch('order/fetchContainerOrderItem', {
              containerUuId: routeTo.params.containerUuId,
              // errorHandle: !routeTo.query.status,
              errorHandle: false,
              showMessage: false,
              logoutRedirect: false,
            }),
            store.dispatch('auth/fetchMember'),
          ]);

          routeTo.params.isMalicious = false

          // API 回傳 { data: { 容器 } }，request 已回傳內層 data；部分情境為 { items: 容器 }
          const orderData = responseOrder?.items ?? responseOrder?.data ?? responseOrder
          if (orderData && (orderData.uuid || orderData.type)) {
            await checkOrder(orderData, routeTo, next);
            routeTo.params.orderItem = mergeContainerOrderItemForDetail(orderData);
          } else if (responseOrder.status === 'MERCHANT_MEMBER_FRONT_MALICIOUS_QUERY_ORDER' && !routeTo.query.status) {
            routeTo.params.isMalicious = true
          } else if (responseOrder.code === 401) {
            return next({
              name: 'logout',
              query: {
                redirectFrom: routeTo.path
              }
            });
          } else {
            routeTo.params.responseError = responseOrder;
          }

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
    },
    props: (route) => ({
      orderItem: route.params.orderItem || {},
      orderType: 'deposit',
      responseError: route.params.responseError || {},
      isMalicious: route.params.isMalicious || false
    }),
  },
]

async function checkOrder(orderItem, routeTo, next) {

  if ((!!orderItem.paymentStatus && orderItem.paymentStatus !== 'UNPAID') && orderItem.status !== 2 && !store.getters['auth/isLoggedIn']) {
    return next({
      name: 'login',
      query: {
        redirectFrom: location.pathname
      }
    });
  } else {
    return Promise.resolve();
  }
}
